import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  ApiRoutes,
  type FeatureFlags,
  type FeatureFlagsPatch,
} from '@condo/contracts';
import { api } from '@/lib/api/client';
import { queryKeys } from '@/lib/api/query-keys';

export function useFeatureFlags(tenantId: string | undefined) {
  return useQuery({
    queryKey: tenantId ? queryKeys.featureFlags(tenantId) : ['__placeholder_ff'],
    queryFn: () => api.get<FeatureFlags>(ApiRoutes.featureFlags(tenantId!)),
    enabled: !!tenantId,
    staleTime: 30_000,
  });
}

export function usePatchFeatureFlags(tenantId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: FeatureFlagsPatch) =>
      api.patch<FeatureFlags, FeatureFlagsPatch>(
        ApiRoutes.featureFlags(tenantId),
        patch,
      ),
    onSuccess: (next) => {
      qc.setQueryData(queryKeys.featureFlags(tenantId), next);
      qc.invalidateQueries({ queryKey: queryKeys.featureFlags(tenantId) });
      qc.invalidateQueries({ queryKey: queryKeys.condominio(tenantId) });
    },
  });
}
